module.exports = __webpack_public_path__ + "static/media/buildingConstruction3.6dd6fd6a.jpg";